import Api from '../../../common/services/api';

export default ({ username }) => () => Api
  .post('/v1/password/reset', { email: username }, false);
